import { render } from "./CallScreen.vue?vue&type=template&id=b42fe5ec&scoped=true&ts=true&lang=pug"
import script from "./CallScreen.vue?vue&type=script&lang=ts"
export * from "./CallScreen.vue?vue&type=script&lang=ts"

import "./CallScreen.vue?vue&type=style&index=0&id=b42fe5ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42fe5ec"]])

export default __exports__